import { useQuery } from '@tanstack/react-query';
import { goalsGenericGraphql, getContributorsData } from './query';
export const QUERY_KEYS = {
  goalsMetric: 'goalsMetric',
  goalsData: 'goalsData',
  contributors: 'contributors',
};

export const useGoalsChartGql = (
  metric: string,
  startDate: string,
  endDate: string,
  selectedTeam: string,
  sprintId: string
) => {
  return useQuery(
    [
      QUERY_KEYS.goalsMetric,
      metric,
      startDate,
      endDate,
      selectedTeam,
      sprintId,
    ],
    () =>
      goalsGenericGraphql(metric, startDate, endDate, selectedTeam, sprintId),
    {
      select: (data) => ({
        ...data.GoalMetricsByType,
        data: JSON.parse(data.GoalMetricsByType.data),
      }),
      enabled: !!metric && !!startDate && !!endDate,
    }
  );
};

export const useContributorsDataGql = (
  filter: {
    teamId: string;
    startDate: string | null;
    endDate: string | null;
    contributorFilters: {
      activeFilters: { field: string; value: string } | null;
      inActiveFilters: { field: string; value: string } | null;
      excluded: 'true' | 'false';
    };
    searchTerm: string;
  },
  pageNumber: number,
  pageSize: number
) => {
  return useQuery(
    [QUERY_KEYS.contributors, filter, pageNumber, pageSize],
    () => getContributorsData(filter, pageNumber, pageSize),
    {
      select: (data) => data.ContributorsData,
    }
  );
};

export default useContributorsDataGql;
